import axios from 'axios'
var apidir = 'registration/agent/'
var apidev = 'http://APIHSVR.HWGDBS:46000/onboarding/';
var apiuat = 'http://APIUATSVR.HWGDBS:46000/onboarding/';
var apiconnect = 'https://connectapi.nadia.com.my/onboarding/';
var apipath = apiconnect + apidir;
var tokenkey = 'pvtax9abe66gr78qx6eyt7wt';

const getDefaultState = () => {
    return {
        PEP:false,
        PEPPosition : '',
        PEPRelationship :'',
        SophisticatedInvestor:false,
        PersonalAsset:false,
        UsResident:'02',
        UsResidentIndicia:[],
        TaxResidency:'1',
        TaxResidencyTIN : [],
        Progress:0,
        VisibleColumns : ['TaxResidency_CountryName', 'TTaxResidencyTIN', 'TaxResidency_UnavailableReason', 'TaxResidency_ReasonB','TaxResidency_IsTINUnavailable'],
        Columns : [
            { name: 'TaxResidency_CountryName', label: 'TaxResidency Country', field: 'TaxResidency_Country', sortable: true },
            { name: 'TaxResidencyTIN', label: 'TaxResidency TIN', field: 'TaxResidency_TIN', sortable: true },
            { name: 'TaxResidency_UnavailableReason', label: 'TaxResidency UnavailableReason', field: 'TaxResidency_UnavailableReason' },
            { name: 'TaxResidency_ReasonB', label: 'TaxResidency ReasonB', field: 'TaxResidency_ReasonB' },
            { name: 'TaxResidency_UnavailableReason', label: 'TaxResidency UnavailableReason', field: 'TaxResidency UnavailableReason' }
        ]
    }
}

const state = getDefaultState()

// getters
const getters = { 
    getTINById: (state) => (id) => {
        return state.TaxResidencyTIN.find(x => x.Id === id)
    },
    FATCAdone: state => {
        var countdone = 0;
        var totalField = 5;
        //console.clear();

        if(state.PersonalAsset!==''){
                
            countdone = countdone + 1;
            //console.log('PersonalAsset -->'+state.PersonalAsset)
        }

        if(state.SophisticatedInvestor!==''){
            
            countdone = countdone + 1;
            //console.log('SophisticatedInvestor -->'+state.SophisticatedInvestor)
        }

        if(state.PEP!==''){
            if(state.PEP== true){
                totalField = totalField + 1
                if((state.PEPPosition!='')&&(state.PEPRelationship!='')){
                    countdone = countdone + 1;
                    
                        // console.log('PEP -->'+state.PEP)
                        // console.log('PEPPosition -->'+state.PEPPosition)
                        // console.log(' PEPRelationship -->'+state.PEPRelationship)
                        
                        // console.log(' countdone -->'+countdone)
                        // console.log(' totalField -->'+totalField)
                }
            }else{
                //totalField = totalField + 1;
                countdone = countdone + 1;
                // console.log(' PEP -->'+state.PEP)
                        
                // console.log(' countdone -->'+countdone)
                // console.log(' totalField -->'+totalField)
            }
        }

        if(state.UsResident!=''){
            if(state.UsResident=='03'){
                if(state.UsResidentIndicia.length >0){
                    //add field
                    totalField = totalField + 1
                    countdone = countdone + 2;
                    // console.log(' UsResidentIndicia -->'+state.UsResidentIndicia)
                    
                    // console.log(' UsResident -->'+state.UsResident)
                        
                    // console.log(' countdone -->'+countdone)
                    // console.log(' totalField -->'+totalField)
                }
            }else{
                countdone = countdone + 1;    
                
                // console.log(' UsResident -->'+state.UsResident)
                        
                // console.log(' countdone -->'+countdone)
                // console.log(' totalField -->'+totalField)
                
            }
           
        }


        if(state.TaxResidency!=''){
            if((state.TaxResidency=='2')||(state.TaxResidency=='3')){
                if(state.TaxResidencyTIN.length>0){
                    countdone = countdone + 2;
                    totalField = totalField + 1;
                    // console.log(' UsResident -->'+state.TaxResidency)
                        
                    // console.log(' TaxResidencyTIN -->'+state.TaxResidencyTIN)
                    // console.log(' countdone -->'+countdone)
                    // console.log(' totalField -->'+totalField)
                    //add count done
                }
            }else if (state.TaxResidency=='1'){
                countdone = countdone + 1;

                // console.log(' UsResident -->'+state.TaxResidency)
                        
                // console.log(' countdone -->'+countdone)
                // console.log(' totalField -->'+totalField)
            }
        }
        var percentdone = countdone / totalField * 100
        // console.log("formulat --> " + countdone +" / "+ percentageToComplete)
        // console.log("totalField --> "+totalField)
        // console.log("percentageToComplete --> "+percentageToComplete)
        // console.log("percentdone --> "+percentdone)
        
        return Math.round(percentdone)
       

    }
}

// actions
const actions = {
    
}

// mutations
const mutations = {
    SET_ProgressFATCA(state){
        var countdone = 0;
        var totalField = 5;
        // console.clear();

        if(state.PersonalAsset!==''){
                
            countdone = countdone + 1;
            // console.log('PersonalAsset -->'+state.PersonalAsset)
        }

        if(state.SophisticatedInvestor!==''){
            
            countdone = countdone + 1;
            // console.log('SophisticatedInvestor -->'+state.SophisticatedInvestor)
        }

        if(state.PEP!==''){
            if(state.PEP== true){
                if((state.PEPPosition!='')&&(state.PEPRelationship!='')){
                    // add count done
                    totalField = totalField + 1
                    countdone = countdone + 2;
                    
                        // console.log('PEP -->'+state.PEP)
                        // console.log('PEPPosition -->'+state.PEPPosition)
                        // console.log(' PEPRelationship -->'+state.PEPRelationship)
                        
                        // console.log(' countdone -->'+countdone)
                        // console.log(' totalField -->'+totalField)
                }
            }else{
                //totalField = totalField + 1;
                countdone = countdone + 1;
                // console.log(' PEP -->'+state.PEP)
                        
                // console.log(' countdone -->'+countdone)
                // console.log(' totalField -->'+totalField)
            }
        }

        if(state.UsResident!=''){
            if(state.UsResident=='03'){
                if(state.UsResidentIndicia.length >0){
                    //add field
                    totalField = totalField + 1
                    countdone = countdone + 2;
                    // console.log(' UsResidentIndicia -->'+state.UsResidentIndicia)
                    
                    // console.log(' UsResident -->'+state.UsResident)
                        
                    // console.log(' countdone -->'+countdone)
                    // console.log(' totalField -->'+totalField)
                }
            }else{
                //add count done
               //totalField = totalField + 1;
                countdone = countdone + 1;    
                
                // console.log(' UsResident -->'+state.UsResident)
                        
                // console.log(' countdone -->'+countdone)
                // console.log(' totalField -->'+totalField)
                
            }
           
        }


        if(state.TaxResidency!=''){
            if((state.TaxResidency=='2')||(state.TaxResidency=='3')){
                if(state.TaxResidencyTIN.length>0){
                    countdone = countdone + 2;
                    totalField = totalField + 1;
                    // console.log(' UsResident -->'+state.TaxResidency)
                        
                    // console.log(' TaxResidencyTIN -->'+state.TaxResidencyTIN)
                    // console.log(' countdone -->'+countdone)
                    // console.log(' totalField -->'+totalField)
                    //add count done
                }
            }else if (state.TaxResidency=='1'){
                countdone = countdone + 1;

                // console.log(' UsResident -->'+state.TaxResidency)
                        
                // console.log(' countdone -->'+countdone)
                // console.log(' totalField -->'+totalField)
            }
        }

         var percentageToComplete = countdone / totalField * 100


        state.Progress = percentageToComplete
        // console.log("formulat --> " + countdone +" / "+ percentageToComplete)
        // console.log("totalField --> "+totalField)
        // console.log("percentageToComplete --> "+percentageToComplete)
        // console.log("percentdone --> "+state.Progress)
        
        return Math.round(state.Progress)
       

        //console.log('Urm.. apeni...'+state.Progress);
    },
    Delete_TIN(state, Id){
        state.index = state.TaxResidencyTIN.findIndex(x => x.Id === Id)
        var index = state.index;
        state.TaxResidencyTIN.splice(index, 1)
    },
    Update_TIN(state, Value){
        state.index = state.TaxResidencyTIN.findIndex(x => x.Id === Value.Id)
        var index = state.index;
        state.TaxResidencyTIN[index].TaxResidency_TIN = Value.TaxResidency_TIN;
        state.TaxResidencyTIN[index].TaxResidency_IsTINUnavailable = Value.TaxResidency_IsTINUnavailable;
        state.TaxResidencyTIN[index].TaxResidency_UnavailableReason = Value.TaxResidency_UnavailableReason;
        state.TaxResidencyTIN[index].TaxResidency_ReasonB = Value.TaxResidency_ReasonB;
        state.TaxResidencyTIN[index].TaxResidency_Country = Value.TaxResidency_Country;
        state.TaxResidencyTIN[index].TaxResidency_CountryName = Value.TaxResidency_CountryName;
    },
    ResetState_FATCA (state) {
        Object.assign(state, getDefaultState())
    }/* ,
    Get_TINDetails(state, Id, TINDetails)
    {   state.index = state.TaxResidencyTIN.findIndex(x => x.Id === Id)
        var index = state.index;
        var TINDetails = state.TaxResidencyTIN[index];
        return TINDetails;
    } */
}

export default {
    state,
    getters,
    actions,
    mutations
}
